export const projects = [
  {
    title: "We Connect",
    subtitle: "Application for Students to communicate with Alumni",
    description:
      "We Connect is a platform for college students and the alumni where they can connect with each other and also see the latest information/announcements from the College. Students can search and schedule calls with seniors and alumni for mentorship and guidance based on their individual needs.",
    image: "./project-1.gif"
  },
  {
    title: "Pet Zilla",
    subtitle: "Pets Social Media",
    description:
      "This web application which I call social media for animals has the functionality to post a picture, liking different posts, and also contributing to the rescue animals through payment interface, depending on the role a person can post the rescue posts which can be used to collect the money required for treatment.",
    image: "./project-2.gif",
  },
  {
    title: "Medi Chain",
    subtitle: "Medical Supply Chain",
    description:
      "Application for supply chain management for medicines with the help of blockchain to make the chain more efficient and transperent.",
    image: "./project-3.gif",
  },
  {
    title: "Scowin",
    subtitle: "Students Vaccination",
    description:
      "Application for Vaccinating school students from school and getting to start a medical application for school level.",
    image: "./project-3.gif",
  }
];

export const education = [
  {
    title: "Full Stack Development",
    subTitle: "Post Graduation Certification in Full Stack Development from BITS Pilani WILP",
    college: "BITS Pilani",
    image: "./bits.jpg"
  }
];

export const skills = [
  "JavaScript",
  "React",
  "Angular",
  "Python Django",
  "Amazon Web Services",
  "Postgres, Django DB",
  "Slack Application Development",
  "Microservice Architecture",
  "Docker, Kubernetes",
  "HTML, CSS",
  "Node, Express JS",
  "Bootstrap, Material UI",
];

export const workExp = [
  {
    company: "Salesforce",
    role: "Full Stack Engineer",
    start: "June, 2021",
    end: "",
    description: `Technologies and Languages worked on - Angular, JavaScript, HTML, CSS, Python Django, Heroku, Slack, Microservice
    Architecture
    Key Achievements In Employment :
    ● Architecting and Developing scalable applications which would help in better sales.
    ● Worked on creating Microservice based applications to reduce duplication across teams.
    ● Worked with various teams to understand their process and to automate it with a Web Application.
    `,
    image: "./salesforce.png"
  },
  {
    company: "Epam Systems",
    role: "Software Engineer",
    start: "Oct, 2020",
    end: "June, 2021",
    description: `Technologies and Languages worked on - Angular, JavaScript, HTML, CSS, Blockchain, Solidity
    Key Achievements In Employment :
    ● A major contribution to developing new features.
    ● Worked on end-to-end features of the application.
    ● Developing applications with best code practices to improve performance, readability, and scalability.
    `,
    image: "./epam.png"
  },
  {
    company: "Epam Systems",
    role: "Junior Software Engineer",
    start: "July, 2019",
    end: "Oct, 2020",
    description: `Technologies and Languages worked on - Angular, TypeScript, JavaScript, CSS3
    Key Achievements In Employment :
    ● Successfully was able to manage several tasks apart from the project.
    ● Given sessions on topics like DragonFly, Web 3.0, and Crypto Wallets.
    ● Optimizing and refactoring the code to improve performance and security aspects in the application.
    `,
    image: "./epam.png"
  },
  {
    company: "Kony Labs",
    role: "Associate Trainee,",
    start: "June, 2018",
    end: "July, 2019",
    description: `Worked on JavaScript, Kony Visualiser, Kony Fabric, HTML, CSS
    Key Achievements In Employment :
    ● Determine the root causes of failures and recommend changes in designs or processing methods.
    ● Incorporate new methods and processes to improve existing operations.
    ● Investigate or resolve operational problems, such as code use variances or bottlenecks.
    `,
    image: "./kony.png"
  },
];



// WEBPACK FOOTER //
// ./src/data.js